import { AxiosInstance } from 'axios';
import { initAxios } from 'utils/axios';
import config from 'config/Config';

class YearTimePeriodAPI {
  instance: AxiosInstance;

  constructor() {
    this.instance = initAxios(
      `${config.get('backendURL')}v2/years-time-periods`
    );
  }

  fetchYearTimePeriods = async () => {
    const { data } = await this.instance.get('/');
    return data;
  };
}

const yearTimePeriodAPI = new YearTimePeriodAPI();
export default yearTimePeriodAPI;
